<template>
  <div class="min-h-screen flex flex-col dark:bg-neutral-900">
    <slot />
  </div>
</template>
